import { newEngine } from './snippets/interface-4a51ce54636f8443/inline0.js';
import { completionKeymap, closeBracketsKeymap } from '@codemirror/autocomplete';
import { defaultKeymap, historyKeymap, indentWithTab } from '@codemirror/commands';
import { defaultHighlightStyle, foldKeymap } from '@codemirror/language';
import { searchKeymap } from '@codemirror/search';
import { Compartment, EditorState } from '@codemirror/state';
import { EditorView, keymap } from '@codemirror/view';
import { getParser } from 'bowser';

let wasm;
export function __wbg_set_wasm(val) {
    wasm = val;
}


const lTextDecoder = typeof TextDecoder === 'undefined' ? (0, module.require)('util').TextDecoder : TextDecoder;

let cachedTextDecoder = new lTextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

let WASM_VECTOR_LEN = 0;

const lTextEncoder = typeof TextEncoder === 'undefined' ? (0, module.require)('util').TextEncoder : TextEncoder;

let cachedTextEncoder = new lTextEncoder('utf-8');

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

const CLOSURE_DTORS = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(state => {
    wasm.__wbindgen_export_3.get(state.dtor)(state.a, state.b)
});

function makeMutClosure(arg0, arg1, dtor, f) {
    const state = { a: arg0, b: arg1, cnt: 1, dtor };
    const real = (...args) => {
        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally {
            if (--state.cnt === 0) {
                wasm.__wbindgen_export_3.get(state.dtor)(a, state.b);
                CLOSURE_DTORS.unregister(state);
            } else {
                state.a = a;
            }
        }
    };
    real.original = state;
    CLOSURE_DTORS.register(real, state, state);
    return real;
}
function __wbg_adapter_38(arg0, arg1, arg2) {
    wasm.closure136_externref_shim(arg0, arg1, arg2);
}

function makeClosure(arg0, arg1, dtor, f) {
    const state = { a: arg0, b: arg1, cnt: 1, dtor };
    const real = (...args) => {
        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        try {
            return f(state.a, state.b, ...args);
        } finally {
            if (--state.cnt === 0) {
                wasm.__wbindgen_export_3.get(state.dtor)(state.a, state.b);
                state.a = 0;
                CLOSURE_DTORS.unregister(state);
            }
        }
    };
    real.original = state;
    CLOSURE_DTORS.register(real, state, state);
    return real;
}
function __wbg_adapter_41(arg0, arg1, arg2) {
    wasm.closure49_externref_shim(arg0, arg1, arg2);
}

function __wbg_adapter_44(arg0, arg1) {
    wasm._dyn_core__ops__function__FnMut_____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h81cfe2f54f5a4fce(arg0, arg1);
}

function __wbg_adapter_47(arg0, arg1) {
    const ret = wasm._dyn_core__ops__function__Fn_____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__hc752369bd0ff188a(arg0, arg1);
    return ret !== 0;
}

function __wbg_adapter_50(arg0, arg1, arg2, arg3, arg4, arg5) {
    wasm._dyn_core__ops__function__Fn__A_B_C_D___Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h2f684d483f5d18c6(arg0, arg1, arg2, arg3, arg4, arg5);
}

function __wbg_adapter_53(arg0, arg1, arg2, arg3, arg4, arg5) {
    wasm._dyn_core__ops__function__Fn__A_B_C_D___Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h2f684d483f5d18c6(arg0, arg1, arg2, arg3, arg4, arg5);
}

function __wbg_adapter_56(arg0, arg1, arg2, arg3, arg4) {
    const ret = wasm._dyn_core__ops__function__Fn__A_B_C___Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h55447df984a46d18(arg0, arg1, arg2, arg3, arg4);
    return ret >>> 0;
}

function __wbg_adapter_59(arg0, arg1, arg2) {
    const ret = wasm._dyn_core__ops__function__Fn__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h78bf7f880928c3d3(arg0, arg1, arg2);
    return ret !== 0;
}

function __wbg_adapter_62(arg0, arg1, arg2, arg3) {
    wasm._dyn_core__ops__function__Fn__A_B___Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__hef3a5deccfe0fde5(arg0, arg1, arg2, arg3);
}

function __wbg_adapter_65(arg0, arg1, arg2, arg3) {
    wasm._dyn_core__ops__function__Fn__A_B___Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h24cfa77558e63815(arg0, arg1, arg2, arg3);
}

function __wbg_adapter_68(arg0, arg1, arg2, arg3) {
    const ret = wasm._dyn_core__ops__function__Fn__A_B___Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__he50ec988492265f8(arg0, arg1, arg2, arg3);
    return ret;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_export_2.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}
function __wbg_adapter_71(arg0, arg1, arg2, arg3, arg4, arg5) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm._dyn_core__ops__function__Fn__A_B_C_D___Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__hed865a60318a3c23(retptr, arg0, arg1, arg2, arg3, arg4, arg5);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeFromExternrefTable0(r1);
        }
        return takeFromExternrefTable0(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

function __wbg_adapter_74(arg0, arg1, arg2) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.closure340_externref_shim(retptr, arg0, arg1, arg2);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeFromExternrefTable0(r1);
        }
        return takeFromExternrefTable0(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

function __wbg_adapter_77(arg0, arg1, arg2) {
    const ret = wasm._dyn_core__ops__function__Fn__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h1070acbe07a673eb(arg0, arg1, arg2);
    return ret >>> 0;
}

function __wbg_adapter_80(arg0, arg1) {
    wasm._dyn_core__ops__function__Fn_____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__hba67a48f7548b98c(arg0, arg1);
}

function __wbg_adapter_83(arg0, arg1, arg2) {
    wasm._dyn_core__ops__function__Fn__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h52211f35d8b27fa9(arg0, arg1, arg2);
}

function __wbg_adapter_86(arg0, arg1) {
    const ret = wasm._dyn_core__ops__function__Fn_____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__hfdc42dea4bb1b906(arg0, arg1);
    return ret;
}

function __wbg_adapter_89(arg0, arg1, arg2, arg3, arg4) {
    wasm._dyn_core__ops__function__Fn__A_B_C___Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h1c6124a7ae2e2a09(arg0, arg1, arg2, arg3, arg4);
}

function __wbg_adapter_92(arg0, arg1) {
    const ret = wasm._dyn_core__ops__function__Fn_____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__hb900ab41c1cb100f(arg0, arg1);
    return ret >>> 0;
}

function __wbg_adapter_95(arg0, arg1, arg2) {
    wasm._dyn_core__ops__function__Fn__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h52211f35d8b27fa9(arg0, arg1, arg2);
}

function __wbg_adapter_98(arg0, arg1, arg2, arg3, arg4) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm._dyn_core__ops__function__Fn__A_B_C___Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h4f1c250213ebf9a4(retptr, arg0, arg1, arg2, arg3, arg4);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeFromExternrefTable0(r1);
        }
        return takeFromExternrefTable0(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

function __wbg_adapter_101(arg0, arg1, arg2, arg3) {
    const ret = wasm._dyn_core__ops__function__Fn__A_B___Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__he50ec988492265f8(arg0, arg1, arg2, arg3);
    return ret >>> 0;
}

function __wbg_adapter_104(arg0, arg1, arg2) {
    wasm.closure395_externref_shim(arg0, arg1, arg2);
}

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_export_2.set(idx, obj);
    return idx;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}
/**
* @returns {Promise<void>}
*/
export function main() {
    wasm.main();
}

function getFromExternrefTable0(idx) { return wasm.__wbindgen_export_2.get(idx); }

function getCachedStringFromWasm0(ptr, len) {
    if (ptr === 0) {
        return getFromExternrefTable0(len);
    } else {
        return getStringFromWasm0(ptr, len);
    }
}

function notDefined(what) { return () => { throw new Error(`${what} is not defined`); }; }

const EnvProxyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_envproxy_free(ptr >>> 0, 1));
/**
*/
export class EnvProxy {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(EnvProxy.prototype);
        obj.__wbg_ptr = ptr;
        EnvProxyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        EnvProxyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_envproxy_free(ptr, 0);
    }
    /**
    * @param {any} arg0
    * @param {any} property
    * @returns {any}
    */
    get(arg0, property) {
        const ret = wasm.envproxy_get(this.__wbg_ptr, arg0, property);
        return ret;
    }
}

const GotFuncProxyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_gotfuncproxy_free(ptr >>> 0, 1));
/**
*/
export class GotFuncProxy {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(GotFuncProxy.prototype);
        obj.__wbg_ptr = ptr;
        GotFuncProxyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GotFuncProxyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_gotfuncproxy_free(ptr, 0);
    }
    /**
    * @param {any} arg0
    * @param {any} property
    * @returns {any}
    */
    get(arg0, property) {
        const ret = wasm.gotfuncproxy_get(this.__wbg_ptr, arg0, property);
        return ret;
    }
}

const GotMemProxyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_gotmemproxy_free(ptr >>> 0, 1));
/**
*/
export class GotMemProxy {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(GotMemProxy.prototype);
        obj.__wbg_ptr = ptr;
        GotMemProxyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GotMemProxyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_gotmemproxy_free(ptr, 0);
    }
    /**
    * @param {any} arg0
    * @param {any} property
    * @returns {any}
    */
    get(arg0, property) {
        const ret = wasm.gotmemproxy_get(this.__wbg_ptr, arg0, property);
        return ret;
    }
}

const WasiProxyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasiproxy_free(ptr >>> 0, 1));
/**
*/
export class WasiProxy {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasiProxyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasiproxy_free(ptr, 0);
    }
    /**
    * @param {any} _proxied_target
    * @param {any} property
    * @returns {any}
    */
    get(_proxied_target, property) {
        const ret = wasm.wasiproxy_get(this.__wbg_ptr, _proxied_target, property);
        return ret;
    }
}

export function __wbg_instanceof_HtmlDivElement_a18fc94130bc218e(arg0) {
    let result;
    try {
        result = arg0 instanceof HTMLDivElement;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_classList_d725bcb3b32c27b5(arg0) {
    const ret = arg0.classList;
    return ret;
};

export function __wbg_style_e06c9e03355741e9(arg0) {
    const ret = arg0.style;
    return ret;
};

export function __wbg_new_525245e2b9901204() {
    const ret = new Object();
    return ret;
};

export function __wbg_setcapture_4818ebe9ef88b2f6(arg0, arg1) {
    arg0.capture = arg1 !== 0;
};

export function __wbg_setonce_06b35a72a3fafc15(arg0, arg1) {
    arg0.once = arg1 !== 0;
};

export function __wbg_setpassive_70ce6704aec553f6(arg0, arg1) {
    arg0.passive = arg1 !== 0;
};

export function __wbg_instanceof_SvgElement_1b0e7dc15e348d0e(arg0) {
    let result;
    try {
        result = arg0 instanceof SVGElement;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_location_af118da6c50d4c3f(arg0) {
    const ret = arg0.location;
    return ret;
};

export function __wbg_hash_313d7fdf42f6e7d3() { return handleError(function (arg0, arg1) {
    const ret = arg1.hash;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}, arguments) };

export function __wbg_instanceof_HtmlElement_ee6cb55e6b90ae79(arg0) {
    let result;
    try {
        result = arg0 instanceof HTMLElement;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_new_77893023789a494c() {
    const ret = new Compartment();
    return ret;
};

export function __wbindgen_string_new(arg0, arg1) {
    const ret = getStringFromWasm0(arg0, arg1);
    return ret;
};

export function __wbg_new_a220cf903aa02ca2() {
    const ret = new Array();
    return ret;
};

export function __wbg_concat_cb0ada623813310e(arg0, arg1) {
    const ret = arg0.concat(arg1);
    return ret;
};

export function __wbg_of_4a1c869ef05b4b73(arg0) {
    const ret = Array.of(arg0);
    return ret;
};

export function __wbg_of_ec81257e328f63dc(arg0, arg1) {
    const ret = arg0.of(arg1);
    return ret;
};

export function __wbg_updatelistener_e14554ebcabeffe3() {
    const ret = EditorView.updateListener;
    return ret;
};

export function __wbg_of_5082613e3aa3ff01(arg0, arg1) {
    const ret = arg0.of(arg1);
    return ret;
};

export function __wbg_push_37c89022f34c01ca(arg0, arg1) {
    const ret = arg0.push(arg1);
    return ret;
};

export function __wbg_create_e90a6b476e067a2a(arg0) {
    const ret = EditorState.create(arg0);
    return ret;
};

export function __wbg_new_617ce75433051891(arg0) {
    const ret = new EditorView(arg0);
    return ret;
};

export function __wbg_setmethod_dc68a742c2db5c6a(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    arg0.method = v0;
};

export function __wbg_setbody_734cb3d7ee8e6e96(arg0, arg1) {
    arg0.body = arg1;
};

export function __wbg_ok_227b0624f5926a87(arg0) {
    const ret = arg0.ok;
    return ret;
};

export function __wbg_origin_648082c4831a5be8() { return handleError(function (arg0, arg1) {
    const ret = arg1.origin;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}, arguments) };

export function __wbg_setscrollTop_177f66fa0e816e58(arg0, arg1) {
    arg0.scrollTop = arg1;
};

export function __wbg_instanceof_HtmlSpanElement_2d098d35873f177c(arg0) {
    let result;
    try {
        result = arg0 instanceof HTMLSpanElement;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_setdata_27c6828c5a5a5ce4(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    arg0.data = v0;
};

export function __wbg_dom_da3e51f576f54b29(arg0) {
    const ret = arg0.dom;
    return ret;
};

export function __wbg_preventDefault_c55d86c27b2dfa6e(arg0) {
    arg0.preventDefault();
};

export function __wbg_deltaX_7f4a9de8338c7ca6(arg0) {
    const ret = arg0.deltaX;
    return ret;
};

export function __wbg_deltaY_606f12aa66daba69(arg0) {
    const ret = arg0.deltaY;
    return ret;
};

export function __wbg_deltaMode_d6b849e45efd0f5e(arg0) {
    const ret = arg0.deltaMode;
    return ret;
};

export function __wbg_offsetX_e7047852d4b4b482(arg0) {
    const ret = arg0.offsetX;
    return ret;
};

export function __wbg_offsetY_76fc66e0e449645e(arg0) {
    const ret = arg0.offsetY;
    return ret;
};

export function __wbg_key_a626396efbca2b95(arg0, arg1) {
    const ret = arg1.key;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_setinnerHTML_ea7e3c6a3c4790c6(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    arg0.innerHTML = v0;
};

export function __wbg_terminate_740ae158c739edb3(arg0) {
    arg0.terminate();
};

export const __wbg_clearTimeout_541ac0980ffcef74 = typeof clearTimeout == 'function' ? clearTimeout : notDefined('clearTimeout');

export function __wbindgen_cb_drop(arg0) {
    const obj = arg0.original;
    if (obj.cnt-- == 1) {
        obj.a = 0;
        return true;
    }
    const ret = false;
    return ret;
};

export function __wbg_new_ea1883e1e5e86686(arg0) {
    const ret = new Uint8Array(arg0);
    return ret;
};

export function __wbg_buffer_0710d1b9dbe2eea6(arg0) {
    const ret = arg0.buffer;
    return ret;
};

export function __wbg_shift_057fce8dec545e17(arg0) {
    const ret = arg0.shift();
    return ret;
};

export function __wbg_instanceof_ArrayBuffer_61dfc3198373c902(arg0) {
    let result;
    try {
        result = arg0 instanceof ArrayBuffer;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_unshift_31c32f16b5313259(arg0, arg1) {
    const ret = arg0.unshift(arg1);
    return ret;
};

export function __wbg_document_8554450897a855b9(arg0) {
    const ret = arg0.document;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_instanceof_HtmlCanvasElement_1a96a01603ec2d8b(arg0) {
    let result;
    try {
        result = arg0 instanceof HTMLCanvasElement;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_data_5c47a6985fefc490(arg0) {
    const ret = arg0.data;
    return ret;
};

export function __wbg_isArray_8364a5371e9737d8(arg0) {
    const ret = Array.isArray(arg0);
    return ret;
};

export function __wbindgen_is_undefined(arg0) {
    const ret = arg0 === undefined;
    return ret;
};

export function __wbg_instanceof_Window_5012736c80a01584(arg0) {
    let result;
    try {
        result = arg0 instanceof Window;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_fetch_f3adf866d8944b41(arg0, arg1) {
    const ret = arg0.fetch(arg1);
    return ret;
};

export function __wbg_instanceof_WorkerGlobalScope_e34c8a505711a78e(arg0) {
    let result;
    try {
        result = arg0 instanceof WorkerGlobalScope;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_fetch_ba7fe179e527d942(arg0, arg1) {
    const ret = arg0.fetch(arg1);
    return ret;
};

export function __wbg_instanceof_Response_e91b7eb7c611a9ae(arg0) {
    let result;
    try {
        result = arg0 instanceof Response;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_settrack_a41cd7adf7daa453(arg0, arg1) {
    arg0.track = arg1;
};

export function __wbg_new_2f005f42183a2a06() { return handleError(function (arg0) {
    const ret = new MediaStreamTrackProcessor(arg0);
    return ret;
}, arguments) };

export function __wbg_readable_fcf8ea6d0da8474d(arg0) {
    const ret = arg0.readable;
    return ret;
};

export function __wbg_stop_d52e7d6ad5f106d8(arg0) {
    arg0.stop();
};

export function __wbg_navigator_6210380287bf8581(arg0) {
    const ret = arg0.navigator;
    return ret;
};

export function __wbg_mediaDevices_faa6b252480b6169() { return handleError(function (arg0) {
    const ret = arg0.mediaDevices;
    return ret;
}, arguments) };

export function __wbg_getSupportedConstraints_d19510272d36b464(arg0) {
    const ret = arg0.getSupportedConstraints();
    return ret;
};

export function __wbg_getfacingmode_74e0b01c671f2c66(arg0) {
    const ret = arg0.facingMode;
    return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
};

export function __wbg_setvideo_595a02280294c105(arg0, arg1) {
    arg0.video = arg1;
};

export function __wbg_getUserMedia_2f9c80e86991353a() { return handleError(function (arg0, arg1) {
    const ret = arg0.getUserMedia(arg1);
    return ret;
}, arguments) };

export function __wbg_instanceof_MediaStream_57025e0723db7c58(arg0) {
    let result;
    try {
        result = arg0 instanceof MediaStream;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_getTracks_a5fa4759e923daa7(arg0) {
    const ret = arg0.getTracks();
    return ret;
};

export function __wbg_length_ae22078168b726f5(arg0) {
    const ret = arg0.length;
    return ret;
};

export function __wbg_get_3baa728f9d58d3f6(arg0, arg1) {
    const ret = arg0[arg1 >>> 0];
    return ret;
};

export function __wbg_instanceof_MediaStreamTrack_5c4ecc5363a0f3a7(arg0) {
    let result;
    try {
        result = arg0 instanceof MediaStreamTrack;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_Error_69bde193b0cc95e3(arg0) {
    let result;
    try {
        result = arg0 instanceof Error;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_message_e18bae0a0e2c097a(arg0) {
    const ret = arg0.message;
    return ret;
};

export function __wbg_cssRules_7c78ad8c5215948f() { return handleError(function (arg0) {
    const ret = arg0.cssRules;
    return ret;
}, arguments) };

export function __wbg_length_cdafbc2aa46b7161(arg0) {
    const ret = arg0.length;
    return ret;
};

export function __wbg_insertRule_2d65fe747e9f9136() { return handleError(function (arg0, arg1, arg2, arg3) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    const ret = arg0.insertRule(v0, arg3 >>> 0);
    return ret;
}, arguments) };

export function __wbg_get_aacdbc5bfa57b980(arg0, arg1) {
    const ret = arg0[arg1 >>> 0];
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_style_c8300026e73776bd(arg0) {
    const ret = arg0.style;
    return ret;
};

export function __wbindgen_number_get(arg0, arg1) {
    const obj = arg1;
    const ret = typeof(obj) === 'number' ? obj : undefined;
    getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
};

export function __wbg_clientY_37d418b8d9c0bb52(arg0) {
    const ret = arg0.clientY;
    return ret;
};

export function __wbg_clientX_3967ecd5e962e1b2(arg0) {
    const ret = arg0.clientX;
    return ret;
};

export function __wbg_subarray_7c2e3576afe181d1(arg0, arg1, arg2) {
    const ret = arg0.subarray(arg1 >>> 0, arg2 >>> 0);
    return ret;
};

export function __wbg_getRandomValues_3aa56aa6edec874c() { return handleError(function (arg0, arg1) {
    arg0.getRandomValues(arg1);
}, arguments) };

export function __wbindgen_memory() {
    const ret = wasm.memory;
    return ret;
};

export function __wbg_buffer_b7b08af79b0b0974(arg0) {
    const ret = arg0.buffer;
    return ret;
};

export function __wbg_newwithbyteoffsetandlength_8a2cb9ca96b27ec9(arg0, arg1, arg2) {
    const ret = new Uint8Array(arg0, arg1 >>> 0, arg2 >>> 0);
    return ret;
};

export function __wbg_randomFillSync_5c9c955aa56b6049() { return handleError(function (arg0, arg1) {
    arg0.randomFillSync(arg1);
}, arguments) };

export function __wbindgen_number_new(arg0) {
    const ret = arg0;
    return ret;
};

export function __wbg_new_7982fb43cfca37ae(arg0) {
    const ret = new Date(arg0);
    return ret;
};

export function __wbg_getTimezoneOffset_c9929a3cc94500fe(arg0) {
    const ret = arg0.getTimezoneOffset();
    return ret;
};

export function __wbg_button_460cdec9f2512a91(arg0) {
    const ret = arg0.button;
    return ret;
};

export function __wbg_getParser_4010584cea831d04(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg0, arg1);
    const ret = getParser(v0, arg2 !== 0);
    return ret;
};

export function __wbg_getEngineName_4e8ba66ed2b64f9b(arg0, arg1) {
    const ret = arg1.getEngineName();
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_instanceof_HtmlButtonElement_998267b26d794a1e(arg0) {
    let result;
    try {
        result = arg0 instanceof HTMLButtonElement;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_newEngine_2bb060fa9b98a2cb() { return handleError(function () {
    const ret = newEngine();
    return ret;
}, arguments) };

export function __wbg_start_f642a950f6c98a0e(arg0) {
    arg0.start();
};

export function __wbg_setTimeout_7d81d052875b0f4f() { return handleError(function (arg0, arg1) {
    const ret = setTimeout(arg0, arg1);
    return ret;
}, arguments) };

export function __wbg_new_8608a2b51a5f6737() {
    const ret = new Map();
    return ret;
};

export function __wbg_set_49185437f0ab06f8(arg0, arg1, arg2) {
    const ret = arg0.set(arg1, arg2);
    return ret;
};

export function __wbg_text_a94b91ea8700357a() { return handleError(function (arg0) {
    const ret = arg0.text();
    return ret;
}, arguments) };

export function __wbg_getItem_cab39762abab3e70() { return handleError(function (arg0, arg1, arg2, arg3) {
    var v0 = getCachedStringFromWasm0(arg2, arg3);
    const ret = arg1.getItem(v0);
    var ptr2 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len2, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr2, true);
}, arguments) };

export function __wbg_setItem_9482185c870abba6() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    var v1 = getCachedStringFromWasm0(arg3, arg4);
    arg0.setItem(v0, v1);
}, arguments) };

export function __wbg_docchanged_2471af6026d28d11(arg0) {
    const ret = arg0.docChanged;
    return ret;
};

export function __wbg_state_1ae57365c4b56355(arg0) {
    const ret = arg0.state;
    return ret;
};

export function __wbg_doc_85f4a27b12de29b0(arg0) {
    const ret = arg0.doc;
    return ret;
};

export function __wbg_toString_097acbf8a534624d(arg0, arg1) {
    const ret = arg1.toString();
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_static_accessor_COMPLETION_KEYMAP_7cf0ae43e68f0922() {
    const ret = completionKeymap;
    return ret;
};

export function __wbg_static_accessor_CLOSE_BRACKETS_KEYMAP_daa68aa19df62a2b() {
    const ret = closeBracketsKeymap;
    return ret;
};

export function __wbg_static_accessor_DEFAULT_KEYMAP_6de06c2c0c4b7700() {
    const ret = defaultKeymap;
    return ret;
};

export function __wbg_static_accessor_HISTORY_KEYMAP_31b14a17a5ba2d42() {
    const ret = historyKeymap;
    return ret;
};

export function __wbg_static_accessor_IDENT_WITH_TAB_f986b4e92893e344() {
    const ret = indentWithTab;
    return ret;
};

export function __wbg_static_accessor_DEFAULT_HIGHLIGHT_STYLE_5dc157d3bfcfc49c() {
    const ret = defaultHighlightStyle;
    return ret;
};

export function __wbg_static_accessor_FOLD_KEYMAP_70476de5d62d1811() {
    const ret = foldKeymap;
    return ret;
};

export function __wbg_static_accessor_SEARCH_KEYMAP_7d4ee2734c9f6a27() {
    const ret = searchKeymap;
    return ret;
};

export function __wbg_static_accessor_KEYMAP_1f943cb4cc94a942() {
    const ret = keymap;
    return ret;
};

export function __wbg_new_abda76e883ba8a5f() {
    const ret = new Error();
    return ret;
};

export function __wbg_stack_658279fe44541cf6(arg0, arg1) {
    const ret = arg1.stack;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_error_f851667af71bcfc6(arg0, arg1) {
    var v0 = getCachedStringFromWasm0(arg0, arg1);
if (arg0 !== 0) { wasm.__wbindgen_free(arg0, arg1, 1); }
console.error(v0);
};

export function __wbg_setProperty_38cfba0ad31a1e12() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    var v1 = getCachedStringFromWasm0(arg3, arg4);
    var v2 = getCachedStringFromWasm0(arg5, arg6);
    arg0.setProperty(v0, v1, v2);
}, arguments) };

export function __wbg_getPropertyValue_b0f0858c3b5f17dd() { return handleError(function (arg0, arg1, arg2, arg3) {
    var v0 = getCachedStringFromWasm0(arg2, arg3);
    const ret = arg1.getPropertyValue(v0);
    const ptr2 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len2, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr2, true);
}, arguments) };

export function __wbg_removeProperty_cfd836a4f7e5e86e() { return handleError(function (arg0, arg1, arg2, arg3) {
    var v0 = getCachedStringFromWasm0(arg2, arg3);
    const ret = arg1.removeProperty(v0);
    const ptr2 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len2, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr2, true);
}, arguments) };

export function __wbg_settype_e90c45490f32e304(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    arg0.type = v0;
};

export function __wbg_head_6c6317d70f23ff16(arg0) {
    const ret = arg0.head;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_sheet_152928b9d3f3e234(arg0) {
    const ret = arg0.sheet;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_createElementNS_78308ee7091c53f7() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    var v1 = getCachedStringFromWasm0(arg3, arg4);
    const ret = arg0.createElementNS(v0, v1);
    return ret;
}, arguments) };

export function __wbg_createTextNode_8bce33cf33bf8f6e(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    const ret = arg0.createTextNode(v0);
    return ret;
};

export function __wbg_createComment_7a1d9856e50567bb(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    const ret = arg0.createComment(v0);
    return ret;
};

export function __wbg_setAttribute_d5540a19be09f8dc() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    var v1 = getCachedStringFromWasm0(arg3, arg4);
    arg0.setAttribute(v0, v1);
}, arguments) };

export function __wbg_add_e210e3b838bff57f() { return handleError(function (arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    arg0.add(v0);
}, arguments) };

export function __wbg_remove_0dd2beafdaa4d9ba() { return handleError(function (arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    arg0.remove(v0);
}, arguments) };

export function __wbg_removeChild_139b30d19f579e41() { return handleError(function (arg0, arg1) {
    const ret = arg0.removeChild(arg1);
    return ret;
}, arguments) };

export function __wbg_insertBefore_5830cdd4d29c3830() { return handleError(function (arg0, arg1, arg2) {
    const ret = arg0.insertBefore(arg1, arg2);
    return ret;
}, arguments) };

export function __wbg_replaceChild_eae514244f69502d() { return handleError(function (arg0, arg1, arg2) {
    const ret = arg0.replaceChild(arg1, arg2);
    return ret;
}, arguments) };

export function __wbg_body_b3bb488e8e54bf4b(arg0) {
    const ret = arg0.body;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_crypto_1d1f22824a6a080c(arg0) {
    const ret = arg0.crypto;
    return ret;
};

export function __wbindgen_is_object(arg0) {
    const val = arg0;
    const ret = typeof(val) === 'object' && val !== null;
    return ret;
};

export function __wbg_process_4a72847cc503995b(arg0) {
    const ret = arg0.process;
    return ret;
};

export function __wbg_versions_f686565e586dd935(arg0) {
    const ret = arg0.versions;
    return ret;
};

export function __wbg_node_104a2ff8d6ea03a2(arg0) {
    const ret = arg0.node;
    return ret;
};

export function __wbindgen_is_string(arg0) {
    const ret = typeof(arg0) === 'string';
    return ret;
};

export function __wbg_require_cca90b1a94a0255b() { return handleError(function () {
    const ret = module.require;
    return ret;
}, arguments) };

export function __wbindgen_is_function(arg0) {
    const ret = typeof(arg0) === 'function';
    return ret;
};

export function __wbg_msCrypto_eb05e62b530a1508(arg0) {
    const ret = arg0.msCrypto;
    return ret;
};

export function __wbg_newwithlength_ec548f448387c968(arg0) {
    const ret = new Uint8Array(arg0 >>> 0);
    return ret;
};

export function __wbg_name_ac78212e803c7941(arg0) {
    const ret = arg0.name;
    return ret;
};

export function __wbg_toString_9d18e102ca933e68(arg0) {
    const ret = arg0.toString();
    return ret;
};

export function __wbg_toString_e17a6671146f47c1(arg0) {
    const ret = arg0.toString();
    return ret;
};

export function __wbg_new_e27c93803e1acc42() { return handleError(function () {
    const ret = new Headers();
    return ret;
}, arguments) };

export function __wbg_new_ac9dbf743c2383ee() { return handleError(function () {
    const ret = new URLSearchParams();
    return ret;
}, arguments) };

export function __wbg_newwithstr_31920be5b8b6d221() { return handleError(function (arg0, arg1) {
    var v0 = getCachedStringFromWasm0(arg0, arg1);
    const ret = new Request(v0);
    return ret;
}, arguments) };

export function __wbg_url_87b699cb6519ba34(arg0, arg1) {
    const ret = arg1.url;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_new_33db4be5d9963ec1() { return handleError(function (arg0, arg1) {
    var v0 = getCachedStringFromWasm0(arg0, arg1);
    const ret = new URL(v0);
    return ret;
}, arguments) };

export function __wbg_search_f384756d8e27fd66(arg0, arg1) {
    const ret = arg1.search;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_setsearch_b9d03a586b9a2fa4(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    arg0.search = v0;
};

export function __wbg_setheaders_be10a5ab566fd06f(arg0, arg1) {
    arg0.headers = arg1;
};

export function __wbg_newwithstrandinit_a31c69e4cc337183() { return handleError(function (arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg0, arg1);
    const ret = new Request(v0, arg2);
    return ret;
}, arguments) };

export function __wbg_self_3093d5d1f7bcb682() { return handleError(function () {
    const ret = self.self;
    return ret;
}, arguments) };

export function __wbg_window_3bcfc4d31bc012f8() { return handleError(function () {
    const ret = window.window;
    return ret;
}, arguments) };

export function __wbg_globalThis_86b222e13bdf32ed() { return handleError(function () {
    const ret = globalThis.globalThis;
    return ret;
}, arguments) };

export function __wbg_global_e5a3fe56f8be9485() { return handleError(function () {
    const ret = global.global;
    return ret;
}, arguments) };

export function __wbg_newnoargs_76313bd6ff35d0f2(arg0, arg1) {
    var v0 = getCachedStringFromWasm0(arg0, arg1);
    const ret = new Function(v0);
    return ret;
};

export function __wbg_call_1084a111329e68ce() { return handleError(function (arg0, arg1) {
    const ret = arg0.call(arg1);
    return ret;
}, arguments) };

export function __wbg_next_f9cb570345655b9a() { return handleError(function (arg0) {
    const ret = arg0.next();
    return ret;
}, arguments) };

export function __wbg_done_bfda7aa8f252b39f(arg0) {
    const ret = arg0.done;
    return ret;
};

export function __wbg_value_6d39332ab4788d86(arg0) {
    const ret = arg0.value;
    return ret;
};

export function __wbindgen_string_get(arg0, arg1) {
    const obj = arg1;
    const ret = typeof(obj) === 'string' ? obj : undefined;
    var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_apply_353f4c9ca391d52b() { return handleError(function (arg0, arg1, arg2) {
    const ret = arg0.apply(arg1, arg2);
    return ret;
}, arguments) };

export function __wbg_call_89af060b4e1523f2() { return handleError(function (arg0, arg1, arg2) {
    const ret = arg0.call(arg1, arg2);
    return ret;
}, arguments) };

export function __wbg_call_7de908392845a9a5() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    const ret = arg0.call(arg1, arg2, arg3, arg4);
    return ret;
}, arguments) };

export function __wbg_get_224d16597dbbfd96() { return handleError(function (arg0, arg1) {
    const ret = Reflect.get(arg0, arg1);
    return ret;
}, arguments) };

export function __wbg_set_eacc7d73fefaafdf() { return handleError(function (arg0, arg1, arg2) {
    const ret = Reflect.set(arg0, arg1, arg2);
    return ret;
}, arguments) };

export function __wbg_get_7f556c7911ba29ab() { return handleError(function (arg0, arg1) {
    const ret = arg0.get(arg1 >>> 0);
    return ret;
}, arguments) };

export function __wbg_grow_4c5079d7be18200e() { return handleError(function (arg0, arg1) {
    const ret = arg0.grow(arg1 >>> 0);
    return ret;
}, arguments) };

export function __wbg_new_458b4a9ee66658f5() { return handleError(function (arg0, arg1) {
    const ret = new WebAssembly.Global(arg0, arg1);
    return ret;
}, arguments) };

export function __wbg_set_d1e79e2388520f18(arg0, arg1, arg2) {
    arg0.set(arg1, arg2 >>> 0);
};

export function __wbg_length_8339fcf5d8ecd12e(arg0) {
    const ret = arg0.length;
    return ret;
};

export const __wbg_random_4a6f48b07d1eab14 = typeof Math.random == 'function' ? Math.random : notDefined('Math.random');

export function __wbg_new_a0719a520adfdb99(arg0) {
    const ret = new Int32Array(arg0);
    return ret;
};

export function __wbg_waitAsync_c9dcd6a9ffda5d61() { return handleError(function (arg0, arg1, arg2) {
    const ret = Atomics.waitAsync(arg0, arg1 >>> 0, arg2);
    return ret;
}, arguments) };

export function __wbg_store_ff1eb2cf67a516c2() { return handleError(function (arg0, arg1, arg2) {
    const ret = Atomics.store(arg0, arg1 >>> 0, arg2);
    return ret;
}, arguments) };

export function __wbg_instanceof_Promise_ae8c7ffdec83f2ae(arg0) {
    let result;
    try {
        result = arg0 instanceof Promise;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_new_5d12bfb7e37fc427(arg0) {
    const ret = new Uint32Array(arg0);
    return ret;
};

export function __wbg_getindex_abc8b5449732d518(arg0, arg1) {
    const ret = arg0[arg1 >>> 0];
    return ret;
};

export function __wbg_slice_b698b331b2ab7d72(arg0, arg1, arg2) {
    const ret = arg0.slice(arg1 >>> 0, arg2 >>> 0);
    return ret;
};

export function __wbg_new_62276da63d582edb() { return handleError(function (arg0) {
    const ret = new WebAssembly.Module(arg0);
    return ret;
}, arguments) };

export const __wbg_compile_af2ced96ed7db3f6 = typeof WebAssembly.compile == 'function' ? WebAssembly.compile : notDefined('WebAssembly.compile');

export function __wbg_getindex_43ea930a1286d573(arg0, arg1) {
    const ret = arg0[arg1 >>> 0];
    return ret;
};

export function __wbg_fill_6dd0e6307b000691(arg0, arg1, arg2, arg3) {
    const ret = arg0.fill(arg1, arg2 >>> 0, arg3 >>> 0);
    return ret;
};

export function __wbg_length_39ca22ed75a7f9dd(arg0) {
    const ret = arg0.length;
    return ret;
};

export function __wbg_setindex_a6bfecc47fdc564e(arg0, arg1, arg2) {
    arg0[arg1 >>> 0] = arg2;
};

export function __wbg_setindex_0029a6cf4950f622(arg0, arg1, arg2) {
    arg0[arg1 >>> 0] = arg2 >>> 0;
};

export function __wbg_envproxy_new(arg0) {
    const ret = EnvProxy.__wrap(arg0);
    return ret;
};

export function __wbg_instanceof_Object_b80213ae6cc9aafb(arg0) {
    let result;
    try {
        result = arg0 instanceof Object;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_bind_418d136d332975f7(arg0, arg1) {
    const ret = arg0.bind(arg1);
    return ret;
};

export function __wbg_new_870484f41f449ab5(arg0, arg1) {
    const ret = new Proxy(arg0, arg1);
    return ret;
};

export function __wbg_gotmemproxy_new(arg0) {
    const ret = GotMemProxy.__wrap(arg0);
    return ret;
};

export function __wbg_gotfuncproxy_new(arg0) {
    const ret = GotFuncProxy.__wrap(arg0);
    return ret;
};

export function __wbg_new_33bad09f4a1b7755() { return handleError(function (arg0, arg1) {
    const ret = new WebAssembly.Instance(arg0, arg1);
    return ret;
}, arguments) };

export const __wbg_instantiate_465fdb439490a3b0 = typeof WebAssembly.instantiate == 'function' ? WebAssembly.instantiate : notDefined('WebAssembly.instantiate');

export function __wbindgen_is_null(arg0) {
    const ret = arg0 === null;
    return ret;
};

export function __wbg_set_63d6cc4bdfa6f77c(arg0, arg1, arg2) {
    const ret = arg0.set(arg1, arg2);
    return ret;
};

export function __wbg_exports_b7a043d9a46df6ae(arg0) {
    const ret = arg0.exports;
    return ret;
};

export function __wbg_entries_7a0e06255456ebcd(arg0) {
    const ret = Object.entries(arg0);
    return ret;
};

export function __wbg_values_a182ed198dd79e93(arg0) {
    const ret = arg0.values();
    return ret;
};

export function __wbg_values_3b5ac1979695a16f(arg0) {
    const ret = Object.values(arg0);
    return ret;
};

export function __wbg_value_77cd20e8636b3c6d(arg0) {
    const ret = arg0.value;
    return ret;
};

export function __wbindgen_is_falsy(arg0) {
    const ret = !arg0;
    return ret;
};

export function __wbg_setvalue_d9f3a3a203372f3b(arg0, arg1) {
    arg0.value = arg1;
};

export function __wbg_customSections_0d0a176435f7515e(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    const ret = WebAssembly.Module.customSections(arg0, v0);
    return ret;
};

export function __wbg_get_47a8b246defcbc11(arg0, arg1) {
    const ret = arg0.get(arg1);
    return ret;
};

export function __wbg_set_557ee95e2495a4e4() { return handleError(function (arg0, arg1, arg2) {
    arg0.set(arg1 >>> 0, arg2);
}, arguments) };

export function __wbg_bind_91e33a5e81a9c884(arg0, arg1, arg2, arg3) {
    const ret = arg0.bind(arg1, arg2, arg3);
    return ret;
};

export function __wbg_grow_15d968a8bbdbe9ae(arg0, arg1) {
    const ret = arg0.grow(arg1 >>> 0);
    return ret;
};

export function __wbg_navigator_db73b5b11a0c5c93(arg0) {
    const ret = arg0.navigator;
    return ret;
};

export function __wbg_userAgent_105bbcdb33968848() { return handleError(function (arg0, arg1) {
    const ret = arg1.userAgent;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}, arguments) };

export function __wbg_call_c6fe275aaa60da79() { return handleError(function (arg0, arg1, arg2, arg3) {
    const ret = arg0.call(arg1, arg2, arg3);
    return ret;
}, arguments) };

export function __wbg_now_b7a162010a9e75b4() {
    const ret = Date.now();
    return ret;
};

export function __wbg_timeOrigin_79da3f6022796227(arg0) {
    const ret = arg0.timeOrigin;
    return ret;
};

export function __wbg_now_a69647afb1f66247(arg0) {
    const ret = arg0.now();
    return ret;
};

export function __wbg_fetch_3da077286e43a958(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    const ret = arg0.fetch(v0);
    return ret;
};

export function __wbg_fetch_0b9f0f8239b62e25(arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    const ret = arg0.fetch(v0);
    return ret;
};

export const __wbg_compileStreaming_6a3e12098ae1ca4b = typeof WebAssembly.compileStreaming == 'function' ? WebAssembly.compileStreaming : notDefined('WebAssembly.compileStreaming');

export function __wbg_instanceof_WorkerNavigator_7222826fd7798b6c(arg0) {
    let result;
    try {
        result = arg0 instanceof WorkerNavigator;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_Performance_cb392f7a86066979(arg0) {
    let result;
    try {
        result = arg0 instanceof Performance;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_DedicatedWorkerGlobalScope_a7feec288dff4a90(arg0) {
    let result;
    try {
        result = arg0 instanceof DedicatedWorkerGlobalScope;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export const __wbg_error_09480e4aadca50ad = typeof console.error == 'function' ? console.error : notDefined('console.error');

export const __wbg_debug_5a33c41aeac15ee6 = typeof console.debug == 'function' ? console.debug : notDefined('console.debug');

export const __wbg_info_c261acb2deacd903 = typeof console.info == 'function' ? console.info : notDefined('console.info');

export const __wbg_warn_2b3adb99ce26c314 = typeof console.warn == 'function' ? console.warn : notDefined('console.warn');

export function __wbindgen_throw(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};

export function __wbindgen_debug_string(arg0, arg1) {
    const ret = debugString(arg1);
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbindgen_rethrow(arg0) {
    throw arg0;
};

export function __wbg_queueMicrotask_48421b3cc9052b68(arg0) {
    const ret = arg0.queueMicrotask;
    return ret;
};

export function __wbg_resolve_570458cb99d56a43(arg0) {
    const ret = Promise.resolve(arg0);
    return ret;
};

export function __wbg_then_95e6edc0f89b73b1(arg0, arg1) {
    const ret = arg0.then(arg1);
    return ret;
};

export const __wbg_queueMicrotask_12a30234db4045d3 = typeof queueMicrotask == 'function' ? queueMicrotask : notDefined('queueMicrotask');

export function __wbg_then_876bb3c633745cc6(arg0, arg1, arg2) {
    const ret = arg0.then(arg1, arg2);
    return ret;
};

export function __wbg_postMessage_b651e498e4c6dbf5() { return handleError(function (arg0, arg1, arg2) {
    arg0.postMessage(arg1, arg2);
}, arguments) };

export function __wbg_postMessage_d3177fea561a31b8() { return handleError(function (arg0, arg1, arg2) {
    arg0.postMessage(arg1, arg2);
}, arguments) };

export function __wbg_postMessage_98693b9d5ee297a6() { return handleError(function (arg0, arg1, arg2) {
    arg0.postMessage(arg1, arg2);
}, arguments) };

export function __wbg_setProperty_ff389e5a7fb9910e() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    var v1 = getCachedStringFromWasm0(arg3, arg4);
    arg0.setProperty(v0, v1);
}, arguments) };

export function __wbg_createElement_5921e9eb06b9ec89() { return handleError(function (arg0, arg1, arg2) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    const ret = arg0.createElement(v0);
    return ret;
}, arguments) };

export function __wbg_addEventListener_14b036ff7cb8747c() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    arg0.addEventListener(v0, arg3, arg4);
}, arguments) };

export function __wbg_removeEventListener_7878b86efe1ab901() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    arg0.removeEventListener(v0, arg3, arg4 !== 0);
}, arguments) };

export function __wbg_transferControlToOffscreen_3a3d6fe63ecd8297() { return handleError(function (arg0) {
    const ret = arg0.transferControlToOffscreen();
    return ret;
}, arguments) };

export function __wbg_userAgent_58dedff4303aeb66() { return handleError(function (arg0, arg1) {
    const ret = arg1.userAgent;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}, arguments) };

export function __wbg_appendChild_ac45d1abddf1b89b() { return handleError(function (arg0, arg1) {
    const ret = arg0.appendChild(arg1);
    return ret;
}, arguments) };

export function __wbg_innerWidth_74051c08b26d0627() { return handleError(function (arg0) {
    const ret = arg0.innerWidth;
    return ret;
}, arguments) };

export function __wbg_innerHeight_c1b7737de203a7f6() { return handleError(function (arg0) {
    const ret = arg0.innerHeight;
    return ret;
}, arguments) };

export function __wbg_localStorage_90db5cb66e840248() { return handleError(function (arg0) {
    const ret = arg0.localStorage;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}, arguments) };

export function __wbg_open_43b3c6577af2a808() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    var v0 = getCachedStringFromWasm0(arg1, arg2);
    var v1 = getCachedStringFromWasm0(arg3, arg4);
    const ret = arg0.open(v0, v1);
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}, arguments) };

export function __wbindgen_closure_wrapper310(arg0, arg1, arg2) {
    const ret = makeMutClosure(arg0, arg1, 137, __wbg_adapter_38);
    return ret;
};

export function __wbindgen_closure_wrapper443(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_41);
    return ret;
};

export function __wbindgen_closure_wrapper1318(arg0, arg1, arg2) {
    const ret = makeMutClosure(arg0, arg1, 137, __wbg_adapter_44);
    return ret;
};

export function __wbindgen_closure_wrapper3534(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_47);
    return ret;
};

export function __wbindgen_closure_wrapper3538(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_50);
    return ret;
};

export function __wbindgen_closure_wrapper3545(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_53);
    return ret;
};

export function __wbindgen_closure_wrapper3553(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_56);
    return ret;
};

export function __wbindgen_closure_wrapper3562(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_59);
    return ret;
};

export function __wbindgen_closure_wrapper3569(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_62);
    return ret;
};

export function __wbindgen_closure_wrapper3575(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_65);
    return ret;
};

export function __wbindgen_closure_wrapper3581(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_68);
    return ret;
};

export function __wbindgen_closure_wrapper3587(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_71);
    return ret;
};

export function __wbindgen_closure_wrapper3594(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_74);
    return ret;
};

export function __wbindgen_closure_wrapper3604(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_77);
    return ret;
};

export function __wbindgen_closure_wrapper3610(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_80);
    return ret;
};

export function __wbindgen_closure_wrapper3614(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_83);
    return ret;
};

export function __wbindgen_closure_wrapper3623(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_86);
    return ret;
};

export function __wbindgen_closure_wrapper3630(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_89);
    return ret;
};

export function __wbindgen_closure_wrapper3636(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_92);
    return ret;
};

export function __wbindgen_closure_wrapper3644(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_95);
    return ret;
};

export function __wbindgen_closure_wrapper3649(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_98);
    return ret;
};

export function __wbindgen_closure_wrapper3680(arg0, arg1, arg2) {
    const ret = makeClosure(arg0, arg1, 50, __wbg_adapter_101);
    return ret;
};

export function __wbindgen_closure_wrapper3969(arg0, arg1, arg2) {
    const ret = makeMutClosure(arg0, arg1, 137, __wbg_adapter_104);
    return ret;
};

export function __wbindgen_init_externref_table() {
    const table = wasm.__wbindgen_export_2;
    const offset = table.grow(4);
    table.set(0, undefined);
    table.set(offset + 0, undefined);
    table.set(offset + 1, null);
    table.set(offset + 2, true);
    table.set(offset + 3, false);
    ;
};

